import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, LinkContainer, Links, StyledLink } from './EpisodeLinks.styles';
import { urlParams } from '../../../../../play-core/hooks/use-search-params';
import SvgPdf from '../../../../../play-core/icons/Pdf';
import { isPdfLink } from '../../../../../play-core/models/Link';
import { parseIntOrUndefined } from '../../../../../play-core/utils/number-helper';
import { idToUrn } from '../../../../../play-core/utils/urn-helper';
import { isInternalLink } from '../../../components/ClickableComponents/PlayLink';
import { usePath, useRoutes, useVideoConfig } from '../../../config/VideoAppContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EpisodeLinks = ({
  links
}) => {
  const {
    t
  } = useTranslation();
  const routes = useRoutes();
  const pdfLinks = links.filter(isPdfLink);
  const externalLinks = links.filter(link => !isPdfLink(link));
  const {
    businessUnit,
    baseUrl
  } = useVideoConfig();
  const {
    videoDetailPath
  } = usePath();
  const getLink = (link, customIcon) => {
    let to = link.link;
    const {
      urn,
      id,
      startTime
    } = urlParams(to);
    if (isInternalLink(routes, baseUrl, to) && id && !urn) {
      to = videoDetailPath({
        urn: idToUrn(id, businessUnit, 'video')
      }, {
        startTime: parseIntOrUndefined(startTime)
      });
    }
    return /*#__PURE__*/_jsx(StyledLink, {
      to: to,
      text: link.title,
      icon: customIcon,
      showDefaultIcon: !customIcon,
      leftAligned: true,
      multilineText: true
    }, `${link.title}-${link.link}`);
  };
  return /*#__PURE__*/_jsxs(LinkContainer, {
    children: [!!externalLinks.length && /*#__PURE__*/_jsxs(Links, {
      children: [/*#__PURE__*/_jsx(Heading, {
        children: t('videoDetailPage.furtherLinksFromBroadcast')
      }), externalLinks.map(link => getLink(link))]
    }), !!pdfLinks.length && /*#__PURE__*/_jsxs(Links, {
      children: [/*#__PURE__*/_jsx(Heading, {
        children: t('global.documents')
      }), pdfLinks.map(link => getLink(link, /*#__PURE__*/_jsx(SvgPdf, {})))]
    })]
  });
};